import { useQuery } from 'react-query';

import { getCrossVersionsTrends as queryFn } from 'api/endPoints/getCrossVersionsTrends';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCrossVersionsTrends = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getCrossVersionsTrends', params],
        queryFn: () => queryFn(params),
        enabled: params?.ids.filter(Boolean).length > 0,
    });
};

export interface QueryParams {
    ids: number[];
}

export interface QueryFnResponse {
    actual: {
        graph: {
            [key: string]: {
                title: string;
                seriesname: string;
                data: [
                    {
                        text: string;
                        displayValue: string;
                        label: number;
                        value: number;
                        actualValue: number;
                    }[],
                ];
                color: string;
                selectedByDefault: boolean;
            };
        };
        info: IToolTip;
    };
    normalized: {
        graph: {
            [key: string]: {
                title: string;
                seriesname: string;
                data: [
                    {
                        text: string;
                        displayValue: string;
                        label: number;
                        value: number;
                        actualValue: number;
                    }[],
                ];
                color: string;
                selectedByDefault: boolean;
            };
        };
        info: IToolTip;
    };
}

type QueryResponse = QueryFnResponse & {};
